import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function ExamGradesPage(){ return <ExtendedModulePage moduleKey="exam-grades"/>; }
